export default {"src":"/_next/static/media/close_button.835b8114.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};